var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isEnhancedMyPage ? 'purchase-history pb-16' : 'pb-16'},[_c('v-sheet',{class:_vm.isEnhancedMyPage ? 'mx-auto' : 'pt-6 mx-auto'},[_c(_vm.reservationComponent,{ref:"reservationList",tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }